import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  noWrapLabel: {
    whiteSpace: 'nowrap',
    marginLeft: 8,
  },
  container: {
    paddingRight: `${theme.spacing(4)}px !important`,
  },
  hidden: {
    display: 'none',
  },
}))

export default useStyles
